/* Voffen motion.

   Two jobs:
     1. Reveal — reuses Dawn's .scroll-trigger--offscreen convention so our
        sections behave like the rest of the theme, and stamps a cascade order
        onto grid children so tiles and bullets arrive in sequence.
     2. Parallax — nudges the paw layer and hero photography as the page moves.

   Both are skipped entirely when the visitor prefers reduced motion, and the
   page is fully laid out without either running. */

(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ------------------------------------------------------------- reveal --- */

  function initReveal() {
    var targets = Array.prototype.slice.call(document.querySelectorAll('.voffen-reveal'));
    if (!targets.length) return;

    // Stamp a cascade order on siblings so a row of tiles arrives in sequence
    // rather than all at once.
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-voffen-cascade]'),
      function (group) {
        Array.prototype.forEach.call(group.children, function (child, i) {
          child.style.setProperty('--voffen-order', i);
        });
      }
    );

    // No observer support: leave everything visible, skip the effect.
    if (!('IntersectionObserver' in window)) return;

    // Anything already on screen animates in on its own short delay rather
    // than waiting for the observer — that is both a nicer entrance and one
    // less thing that can leave the first paint blank.
    var inView = function (el) {
      var box = el.getBoundingClientRect();
      return box.top < window.innerHeight * 0.9 && box.bottom > 0;
    };

    var deferred = targets.filter(function (el) {
      return !inView(el);
    });

    document.documentElement.classList.add('voffen-motion-ready');
    deferred.forEach(function (el) {
      el.classList.add('scroll-trigger--offscreen');
    });

    var observed = false;
    var observer = new IntersectionObserver(
      function (entries) {
        observed = true;
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.remove('scroll-trigger--offscreen');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -60px 0px', threshold: 0.05 }
    );

    deferred.forEach(function (el) {
      observer.observe(el);
    });

    // Safety net. If the observer has not reported at all after a couple of
    // seconds — throttled tab, odd embedding, anything — show everything
    // rather than leaving the page hidden.
    if (deferred.length) {
      window.setTimeout(function () {
        if (observed) return;
        deferred.forEach(function (el) {
          el.classList.remove('scroll-trigger--offscreen');
        });
      }, 2500);
    }
  }

  /* ----------------------------------------------------------- parallax --- */

  function initParallax() {
    var layers = Array.prototype.slice.call(
      document.querySelectorAll('.voffen-paw, .voffen-parallax-media')
    );
    if (!layers.length) return;

    var ticking = false;

    function speedOf(el) {
      var raw = parseFloat(el.getAttribute('data-speed'));
      return isNaN(raw) ? 0.12 : raw;
    }

    function update() {
      ticking = false;
      var mid = window.innerHeight / 2;

      layers.forEach(function (el) {
        var box = el.getBoundingClientRect();

        // Skip anything comfortably offscreen — no point paying for it.
        if (box.bottom < -200 || box.top > window.innerHeight + 200) return;

        var fromCentre = box.top + box.height / 2 - mid;
        var offset = -fromCentre * speedOf(el);

        // Clamp so nothing drifts far enough to leave its band.
        if (offset > 60) offset = 60;
        if (offset < -60) offset = -60;

        el.style.setProperty('--voffen-parallax', offset.toFixed(1) + 'px');
      });
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  /* --------------------------------------------------------------- boot --- */

  function init() {
    if (reduced.matches) return;
    initReveal();
    initParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Sections are re-rendered as you edit them in the theme editor.
  document.addEventListener('shopify:section:load', function () {
    if (reduced.matches) return;
    initReveal();
    initParallax();
  });
})();
